type DesktopBackendHost = {
  electronAPI?: {
    getBackendEndpoint?: () => Promise<string | null>;
    getBackendPort?: () => Promise<number | null>;
  } | null;
} | null;

function normalizeEndpoint(endpoint: string | null | undefined): string {
  return (endpoint || '').trim().replace(/\/+$/, '');
}

export type BackendReadyEvent = {
  success: boolean;
  port?: number;
  remoteEndpoint?: string;
  error?: string;
};

export function resolveBackendReadyEndpoint(
  data: BackendReadyEvent
): string {
  if (!data.success) return '';

  const remoteEndpoint = normalizeEndpoint(data.remoteEndpoint);
  if (remoteEndpoint) return remoteEndpoint;

  if (data.port && data.port > 0) {
    return `http://localhost:${data.port}`;
  }

  return '';
}

export async function resolveDesktopBackendEndpoint(
  host: DesktopBackendHost
): Promise<string> {
  const remoteEndpoint = normalizeEndpoint(
    await host?.electronAPI?.getBackendEndpoint?.()
  );
  if (remoteEndpoint) return remoteEndpoint;

  const backendPort = await host?.electronAPI?.getBackendPort?.();
  if (backendPort && backendPort > 0) {
    return `http://localhost:${backendPort}`;
  }

  return '';
}
